export type AbilityGroup =
  | 'manage_comments'
  | 'manage_tasks'
  | 'manage_datasets'
  | 'manage_team'
  | 'manage_team_members'
  | 'manage_models'

export type Group = { id: AbilityGroup; name: string }
export type GroupOption = Group & { selected: boolean }

export enum SupportedLanguages {
  shell = 'shell',
  python = 'python',
  javascript = 'javascript',
  elixir = 'elixir',
  cli = 'cli',
}

export type AccessCodeExample = { language: SupportedLanguages; code: string }

export type Ability = {
  id: AbilityID
  name: string
  info: string
}

export type AbilityOption = Ability & {
  selected: boolean
}

export type AbilityID =
  | 'archive_dataset_items'
  | 'archive_dataset'
  | 'archive_team'
  | 'assign_items'
  | 'create_annotation_class'
  | 'create_comment_thread'
  | 'create_comment'
  | 'create_dataset'
  | 'create_team'
  | 'delete_annotation_class'
  | 'delete_comment_thread'
  | 'delete_comment'
  | 'delete_dataset_items'
  | 'delete_membership'
  | 'deploy_model'
  | 'export_dataset'
  | 'import_annotations'
  | 'manage_customer'
  | 'manage_invitations'
  | 'run_inference'
  | 'train_models'
  | 'transfer_team_ownership'
  | 'update_annotation_class'
  | 'update_comment_thread'
  | 'update_comment'
  | 'update_dataset_data'
  | 'update_dataset'
  | 'update_membership'
  | 'update_stage'
  | 'update_team'
  | 'view_annotation_classes'
  | 'view_annotation_report'
  | 'view_annotations'
  | 'view_comment_threads'
  | 'view_dataset_exports'
  | 'view_dataset_report'
  | 'view_datasets'
  | 'view_invitations'
  | 'view_models'
  | 'view_team_members'
  | 'view_team'

export type ApiKeyPermission = [AbilityID, 'all' | string]

export type ApiKeyPayload = {
  id: number
  name: string
  permissions: ApiKeyPermission[]
  prefix: string
  team_id: number
  user_id: number
}
